import { getRequest } from '@/core';
import { savedOrderSearches } from '@/requests';

export default async function getSavedOrderSearchesRequest(filter) {
	let url = savedOrderSearches.getPath();
	let response = await getRequest(url, filter);
	return response;
}
